export default "__VITE_ASSET__CgPGBurv__"